// Loader placeholder
import React from 'react';

export default function Loader() {
  return null;
}
